import {gql} from "@irati/utils/gql"

import CompanyNewsTileFragment from "../fragments/CompanyNewsTile"

const mutation = gql`
  mutation CreateCompanyNewsRow($tenantId: String!, $tiles: [CompanyNewsTileInput!]!) {
    createCompanyNewsRow(tenantId: $tenantId, tiles: $tiles) {
      ...CompanyNewsTileFragment
    }
  }

  ${CompanyNewsTileFragment}
`

export const toString = mutation.loc.source.body

export default mutation
